import { useParams, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import InsightDetailContent from './components/InsightDetailContent';
import { insightArticles } from '@/mocks/insights';

export default function InsightDetail() {
  const { id } = useParams<{ id: string }>();
  const article = insightArticles.find((a) => a.id === id);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [id]);

  if (!article) {
    return <Navigate to="/insights" replace />;
  }

  return (
    <div className="min-h-screen bg-[#fafaf8]">
      <Navbar />
      <main className="pt-20">
        <InsightDetailContent article={article} />
      </main>
      <Footer />
    </div>
  );
}
